import { render, staticRenderFns } from "./MissingInformations.vue?vue&type=template&id=36be1b58&scoped=true"
import script from "./MissingInformations.vue?vue&type=script&lang=js"
export * from "./MissingInformations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36be1b58",
  null
  
)

export default component.exports